import { render, staticRenderFns } from "./ObjectionHistoryModal.vue?vue&type=template&id=714394b6&scoped=true"
import script from "./ObjectionHistoryModal.vue?vue&type=script&lang=js"
export * from "./ObjectionHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./ObjectionHistoryModal.vue?vue&type=style&index=0&id=714394b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714394b6",
  null
  
)

export default component.exports